import { post, serialize } from '../httpClient';

export const authAPI = {
  createUserWithIdp: body => post('/api/auth/create-user-with-idp', serialize(body)),
};
